//this file is autogenerated - do not edit
const countryCodesToTimezones = {
  AD: [
    {
      comments: "",
      coordinates: "+4230+00131",
      tz: "Europe/Andorra",
    },
  ],
  AE: [
    {
      comments: "",
      coordinates: "+2518+05518",
      tz: "Asia/Dubai",
    },
  ],
  AF: [
    {
      comments: "",
      coordinates: "+3431+06912",
      tz: "Asia/Kabul",
    },
  ],
  AG: [
    {
      comments: "",
      coordinates: "+1703-06148",
      tz: "America/Antigua",
    },
  ],
  AI: [
    {
      comments: "",
      coordinates: "+1812-06304",
      tz: "America/Anguilla",
    },
  ],
  AL: [
    {
      comments: "",
      coordinates: "+4120+01950",
      tz: "Europe/Tirane",
    },
  ],
  AM: [
    {
      comments: "",
      coordinates: "+4011+04430",
      tz: "Asia/Yerevan",
    },
  ],
  AO: [
    {
      comments: "",
      coordinates: "-0848+01314",
      tz: "Africa/Luanda",
    },
  ],
  AQ: [
    {
      comments: "Casey",
      coordinates: "-6617+11031",
      tz: "Antarctica/Casey",
    },
    {
      comments: "Davis",
      coordinates: "-6835+07758",
      tz: "Antarctica/Davis",
    },
    {
      comments: "Dumont-d'Urville",
      coordinates: "-6640+14001",
      tz: "Antarctica/DumontDUrville",
    },
    {
      comments: "Mawson",
      coordinates: "-6736+06253",
      tz: "Antarctica/Mawson",
    },
    {
      comments: "New Zealand time - McMurdo, South Pole",
      coordinates: "-7750+16636",
      tz: "Antarctica/McMurdo",
    },
    {
      comments: "Palmer",
      coordinates: "-6448-06406",
      tz: "Antarctica/Palmer",
    },
    {
      comments: "Rothera",
      coordinates: "-6734-06808",
      tz: "Antarctica/Rothera",
    },
    {
      comments: "Syowa",
      coordinates: "-690022+0393524",
      tz: "Antarctica/Syowa",
    },
    {
      comments: "Troll",
      coordinates: "-720041+0023206",
      tz: "Antarctica/Troll",
    },
    {
      comments: "Vostok",
      coordinates: "-7824+10654",
      tz: "Antarctica/Vostok",
    },
  ],
  AR: [
    {
      comments: "Buenos Aires (BA, CF)",
      coordinates: "-3436-05827",
      tz: "America/Argentina/Buenos_Aires",
    },
    {
      comments: "Catamarca (CT), Chubut (CH)",
      coordinates: "-2828-06547",
      tz: "America/Argentina/Catamarca",
    },
    {
      comments: "Argentina (most areas: CB, CC, CN, ER, FM, MN, SE, SF)",
      coordinates: "-3124-06411",
      tz: "America/Argentina/Cordoba",
    },
    {
      comments: "Jujuy (JY)",
      coordinates: "-2411-06518",
      tz: "America/Argentina/Jujuy",
    },
    {
      comments: "La Rioja (LR)",
      coordinates: "-2926-06651",
      tz: "America/Argentina/La_Rioja",
    },
    {
      comments: "Mendoza (MZ)",
      coordinates: "-3253-06849",
      tz: "America/Argentina/Mendoza",
    },
    {
      comments: "Santa Cruz (SC)",
      coordinates: "-5138-06913",
      tz: "America/Argentina/Rio_Gallegos",
    },
    {
      comments: "Salta (SA, LP, NQ, RN)",
      coordinates: "-2447-06525",
      tz: "America/Argentina/Salta",
    },
    {
      comments: "San Juan (SJ)",
      coordinates: "-3132-06831",
      tz: "America/Argentina/San_Juan",
    },
    {
      comments: "San Luis (SL)",
      coordinates: "-3319-06621",
      tz: "America/Argentina/San_Luis",
    },
    {
      comments: "Tucuman (TM)",
      coordinates: "-2649-06513",
      tz: "America/Argentina/Tucuman",
    },
    {
      comments: "Tierra del Fuego (TF)",
      coordinates: "-5448-06818",
      tz: "America/Argentina/Ushuaia",
    },
  ],
  AS: [
    {
      comments: "",
      coordinates: "-1416-17042",
      tz: "Pacific/Pago_Pago",
    },
  ],
  AT: [
    {
      comments: "",
      coordinates: "+4813+01620",
      tz: "Europe/Vienna",
    },
  ],
  AU: [
    {
      comments: "Macquarie Island",
      coordinates: "-5430+15857",
      tz: "Antarctica/Macquarie",
    },
    {
      comments: "South Australia",
      coordinates: "-3455+13835",
      tz: "Australia/Adelaide",
    },
    {
      comments: "Queensland (most areas)",
      coordinates: "-2728+15302",
      tz: "Australia/Brisbane",
    },
    {
      comments: "New South Wales (Yancowinna)",
      coordinates: "-3157+14127",
      tz: "Australia/Broken_Hill",
    },
    {
      comments: "Northern Territory",
      coordinates: "-1228+13050",
      tz: "Australia/Darwin",
    },
    {
      comments: "Western Australia (Eucla)",
      coordinates: "-3143+12852",
      tz: "Australia/Eucla",
    },
    {
      comments: "Tasmania",
      coordinates: "-4253+14719",
      tz: "Australia/Hobart",
    },
    {
      comments: "Queensland (Whitsunday Islands)",
      coordinates: "-2016+14900",
      tz: "Australia/Lindeman",
    },
    {
      comments: "Lord Howe Island",
      coordinates: "-3133+15905",
      tz: "Australia/Lord_Howe",
    },
    {
      comments: "Victoria",
      coordinates: "-3749+14458",
      tz: "Australia/Melbourne",
    },
    {
      comments: "Western Australia (most areas)",
      coordinates: "-3157+11551",
      tz: "Australia/Perth",
    },
    {
      comments: "New South Wales (most areas)",
      coordinates: "-3352+15113",
      tz: "Australia/Sydney",
    },
  ],
  AW: [
    {
      comments: "",
      coordinates: "+1230-06958",
      tz: "America/Aruba",
    },
  ],
  AX: [
    {
      comments: "",
      coordinates: "+6006+01957",
      tz: "Europe/Mariehamn",
    },
  ],
  AZ: [
    {
      comments: "",
      coordinates: "+4023+04951",
      tz: "Asia/Baku",
    },
  ],
  BA: [
    {
      comments: "",
      coordinates: "+4352+01825",
      tz: "Europe/Sarajevo",
    },
  ],
  BB: [
    {
      comments: "",
      coordinates: "+1306-05937",
      tz: "America/Barbados",
    },
  ],
  BD: [
    {
      comments: "",
      coordinates: "+2343+09025",
      tz: "Asia/Dhaka",
    },
  ],
  BE: [
    {
      comments: "",
      coordinates: "+5050+00420",
      tz: "Europe/Brussels",
    },
  ],
  BF: [
    {
      comments: "",
      coordinates: "+1222-00131",
      tz: "Africa/Ouagadougou",
    },
  ],
  BG: [
    {
      comments: "",
      coordinates: "+4241+02319",
      tz: "Europe/Sofia",
    },
  ],
  BH: [
    {
      comments: "",
      coordinates: "+2623+05035",
      tz: "Asia/Bahrain",
    },
  ],
  BI: [
    {
      comments: "",
      coordinates: "-0323+02922",
      tz: "Africa/Bujumbura",
    },
  ],
  BJ: [
    {
      comments: "",
      coordinates: "+0629+00237",
      tz: "Africa/Porto-Novo",
    },
  ],
  BL: [
    {
      comments: "",
      coordinates: "+1753-06251",
      tz: "America/St_Barthelemy",
    },
  ],
  BM: [
    {
      comments: "",
      coordinates: "+3217-06446",
      tz: "Atlantic/Bermuda",
    },
  ],
  BN: [
    {
      comments: "",
      coordinates: "+0456+11455",
      tz: "Asia/Brunei",
    },
  ],
  BO: [
    {
      comments: "",
      coordinates: "-1630-06809",
      tz: "America/La_Paz",
    },
  ],
  BQ: [
    {
      comments: "",
      coordinates: "+120903-0681636",
      tz: "America/Kralendijk",
    },
  ],
  BR: [
    {
      comments: "Tocantins",
      coordinates: "-0712-04812",
      tz: "America/Araguaina",
    },
    {
      comments: "Bahia",
      coordinates: "-1259-03831",
      tz: "America/Bahia",
    },
    {
      comments: "Para (east), Amapa",
      coordinates: "-0127-04829",
      tz: "America/Belem",
    },
    {
      comments: "Roraima",
      coordinates: "+0249-06040",
      tz: "America/Boa_Vista",
    },
    {
      comments: "Mato Grosso do Sul",
      coordinates: "-2027-05437",
      tz: "America/Campo_Grande",
    },
    {
      comments: "Mato Grosso",
      coordinates: "-1535-05605",
      tz: "America/Cuiaba",
    },
    {
      comments: "Amazonas (west)",
      coordinates: "-0640-06952",
      tz: "America/Eirunepe",
    },
    {
      comments: "Brazil (northeast: MA, PI, CE, RN, PB)",
      coordinates: "-0343-03830",
      tz: "America/Fortaleza",
    },
    {
      comments: "Alagoas, Sergipe",
      coordinates: "-0940-03543",
      tz: "America/Maceio",
    },
    {
      comments: "Amazonas (east)",
      coordinates: "-0308-06001",
      tz: "America/Manaus",
    },
    {
      comments: "Atlantic islands",
      coordinates: "-0351-03225",
      tz: "America/Noronha",
    },
    {
      comments: "Rondonia",
      coordinates: "-0846-06354",
      tz: "America/Porto_Velho",
    },
    {
      comments: "Pernambuco",
      coordinates: "-0803-03454",
      tz: "America/Recife",
    },
    {
      comments: "Acre",
      coordinates: "-0958-06748",
      tz: "America/Rio_Branco",
    },
    {
      comments: "Para (west)",
      coordinates: "-0226-05452",
      tz: "America/Santarem",
    },
    {
      comments: "Brazil (southeast: GO, DF, MG, ES, RJ, SP, PR, SC, RS)",
      coordinates: "-2332-04637",
      tz: "America/Sao_Paulo",
    },
  ],
  BS: [
    {
      comments: "",
      coordinates: "+2505-07721",
      tz: "America/Nassau",
    },
  ],
  BT: [
    {
      comments: "",
      coordinates: "+2728+08939",
      tz: "Asia/Thimphu",
    },
  ],
  BW: [
    {
      comments: "",
      coordinates: "-2439+02555",
      tz: "Africa/Gaborone",
    },
  ],
  BY: [
    {
      comments: "",
      coordinates: "+5354+02734",
      tz: "Europe/Minsk",
    },
  ],
  BZ: [
    {
      comments: "",
      coordinates: "+1730-08812",
      tz: "America/Belize",
    },
  ],
  CA: [
    {
      comments: "EST - ON (Atikokan), NU (Coral H)",
      coordinates: "+484531-0913718",
      tz: "America/Atikokan",
    },
    {
      comments: "AST - QC (Lower North Shore)",
      coordinates: "+5125-05707",
      tz: "America/Blanc-Sablon",
    },
    {
      comments: "Mountain - NU (west)",
      coordinates: "+690650-1050310",
      tz: "America/Cambridge_Bay",
    },
    {
      comments: "MST - BC (Creston)",
      coordinates: "+4906-11631",
      tz: "America/Creston",
    },
    {
      comments: "MST - Yukon (west)",
      coordinates: "+6404-13925",
      tz: "America/Dawson",
    },
    {
      comments: "MST - BC (Dawson Cr, Ft St John)",
      coordinates: "+5546-12014",
      tz: "America/Dawson_Creek",
    },
    {
      comments: "Mountain - AB, BC(E), NT(E), SK(W)",
      coordinates: "+5333-11328",
      tz: "America/Edmonton",
    },
    {
      comments: "MST - BC (Ft Nelson)",
      coordinates: "+5848-12242",
      tz: "America/Fort_Nelson",
    },
    {
      comments: "Atlantic - NS (Cape Breton)",
      coordinates: "+4612-05957",
      tz: "America/Glace_Bay",
    },
    {
      comments: "Atlantic - Labrador (most areas)",
      coordinates: "+5320-06025",
      tz: "America/Goose_Bay",
    },
    {
      comments: "Atlantic - NS (most areas), PE",
      coordinates: "+4439-06336",
      tz: "America/Halifax",
    },
    {
      comments: "Mountain - NT (west)",
      coordinates: "+682059-1334300",
      tz: "America/Inuvik",
    },
    {
      comments: "Eastern - NU (most areas)",
      coordinates: "+6344-06828",
      tz: "America/Iqaluit",
    },
    {
      comments: "Atlantic - New Brunswick",
      coordinates: "+4606-06447",
      tz: "America/Moncton",
    },
    {
      comments: "Central - NU (central)",
      coordinates: "+624900-0920459",
      tz: "America/Rankin_Inlet",
    },
    {
      comments: "CST - SK (most areas)",
      coordinates: "+5024-10439",
      tz: "America/Regina",
    },
    {
      comments: "Central - NU (Resolute)",
      coordinates: "+744144-0944945",
      tz: "America/Resolute",
    },
    {
      comments: "Newfoundland, Labrador (SE)",
      coordinates: "+4734-05243",
      tz: "America/St_Johns",
    },
    {
      comments: "CST - SK (midwest)",
      coordinates: "+5017-10750",
      tz: "America/Swift_Current",
    },
    {
      comments: "Eastern - ON & QC (most areas)",
      coordinates: "+4339-07923",
      tz: "America/Toronto",
    },
    {
      comments: "Pacific - BC (most areas)",
      coordinates: "+4916-12307",
      tz: "America/Vancouver",
    },
    {
      comments: "MST - Yukon (east)",
      coordinates: "+6043-13503",
      tz: "America/Whitehorse",
    },
    {
      comments: "Central - ON (west), Manitoba",
      coordinates: "+4953-09709",
      tz: "America/Winnipeg",
    },
  ],
  CC: [
    {
      comments: "",
      coordinates: "-1210+09655",
      tz: "Indian/Cocos",
    },
  ],
  CD: [
    {
      comments: "Dem. Rep. of Congo (west)",
      coordinates: "-0418+01518",
      tz: "Africa/Kinshasa",
    },
    {
      comments: "Dem. Rep. of Congo (east)",
      coordinates: "-1140+02728",
      tz: "Africa/Lubumbashi",
    },
  ],
  CF: [
    {
      comments: "",
      coordinates: "+0422+01835",
      tz: "Africa/Bangui",
    },
  ],
  CG: [
    {
      comments: "",
      coordinates: "-0416+01517",
      tz: "Africa/Brazzaville",
    },
  ],
  CH: [
    {
      comments: "",
      coordinates: "+4723+00832",
      tz: "Europe/Zurich",
    },
  ],
  CI: [
    {
      comments: "",
      coordinates: "+0519-00402",
      tz: "Africa/Abidjan",
    },
  ],
  CK: [
    {
      comments: "",
      coordinates: "-2114-15946",
      tz: "Pacific/Rarotonga",
    },
  ],
  CL: [
    {
      comments: "Region of Magallanes",
      coordinates: "-5309-07055",
      tz: "America/Punta_Arenas",
    },
    {
      comments: "most of Chile",
      coordinates: "-3327-07040",
      tz: "America/Santiago",
    },
    {
      comments: "Easter Island",
      coordinates: "-2709-10926",
      tz: "Pacific/Easter",
    },
  ],
  CM: [
    {
      comments: "",
      coordinates: "+0403+00942",
      tz: "Africa/Douala",
    },
  ],
  CN: [
    {
      comments: "Beijing Time",
      coordinates: "+3114+12128",
      tz: "Asia/Shanghai",
    },
    {
      comments: "Xinjiang Time",
      coordinates: "+4348+08735",
      tz: "Asia/Urumqi",
    },
  ],
  CO: [
    {
      comments: "",
      coordinates: "+0436-07405",
      tz: "America/Bogota",
    },
  ],
  CR: [
    {
      comments: "",
      coordinates: "+0956-08405",
      tz: "America/Costa_Rica",
    },
  ],
  CU: [
    {
      comments: "",
      coordinates: "+2308-08222",
      tz: "America/Havana",
    },
  ],
  CV: [
    {
      comments: "",
      coordinates: "+1455-02331",
      tz: "Atlantic/Cape_Verde",
    },
  ],
  CW: [
    {
      comments: "",
      coordinates: "+1211-06900",
      tz: "America/Curacao",
    },
  ],
  CX: [
    {
      comments: "",
      coordinates: "-1025+10543",
      tz: "Indian/Christmas",
    },
  ],
  CY: [
    {
      comments: "Northern Cyprus",
      coordinates: "+3507+03357",
      tz: "Asia/Famagusta",
    },
    {
      comments: "most of Cyprus",
      coordinates: "+3510+03322",
      tz: "Asia/Nicosia",
    },
  ],
  CZ: [
    {
      comments: "",
      coordinates: "+5005+01426",
      tz: "Europe/Prague",
    },
  ],
  DE: [
    {
      comments: "most of Germany",
      coordinates: "+5230+01322",
      tz: "Europe/Berlin",
    },
    {
      comments: "Busingen",
      coordinates: "+4742+00841",
      tz: "Europe/Busingen",
    },
  ],
  DJ: [
    {
      comments: "",
      coordinates: "+1136+04309",
      tz: "Africa/Djibouti",
    },
  ],
  DK: [
    {
      comments: "",
      coordinates: "+5540+01235",
      tz: "Europe/Copenhagen",
    },
  ],
  DM: [
    {
      comments: "",
      coordinates: "+1518-06124",
      tz: "America/Dominica",
    },
  ],
  DO: [
    {
      comments: "",
      coordinates: "+1828-06954",
      tz: "America/Santo_Domingo",
    },
  ],
  DZ: [
    {
      comments: "",
      coordinates: "+3647+00303",
      tz: "Africa/Algiers",
    },
  ],
  EC: [
    {
      comments: "Ecuador (mainland)",
      coordinates: "-0210-07950",
      tz: "America/Guayaquil",
    },
    {
      comments: "Galapagos Islands",
      coordinates: "-0054-08936",
      tz: "Pacific/Galapagos",
    },
  ],
  EE: [
    {
      comments: "",
      coordinates: "+5925+02445",
      tz: "Europe/Tallinn",
    },
  ],
  EG: [
    {
      comments: "",
      coordinates: "+3003+03115",
      tz: "Africa/Cairo",
    },
  ],
  EH: [
    {
      comments: "",
      coordinates: "+2709-01312",
      tz: "Africa/El_Aaiun",
    },
  ],
  ER: [
    {
      comments: "",
      coordinates: "+1520+03853",
      tz: "Africa/Asmara",
    },
  ],
  ES: [
    {
      comments: "Ceuta, Melilla",
      coordinates: "+3553-00519",
      tz: "Africa/Ceuta",
    },
    {
      comments: "Canary Islands",
      coordinates: "+2806-01524",
      tz: "Atlantic/Canary",
    },
    {
      comments: "Spain (mainland)",
      coordinates: "+4024-00341",
      tz: "Europe/Madrid",
    },
  ],
  ET: [
    {
      comments: "",
      coordinates: "+0902+03842",
      tz: "Africa/Addis_Ababa",
    },
  ],
  FI: [
    {
      comments: "",
      coordinates: "+6010+02458",
      tz: "Europe/Helsinki",
    },
  ],
  FJ: [
    {
      comments: "",
      coordinates: "-1808+17825",
      tz: "Pacific/Fiji",
    },
  ],
  FK: [
    {
      comments: "",
      coordinates: "-5142-05751",
      tz: "Atlantic/Stanley",
    },
  ],
  FM: [
    {
      comments: "Chuuk/Truk, Yap",
      coordinates: "+0725+15147",
      tz: "Pacific/Chuuk",
    },
    {
      comments: "Kosrae",
      coordinates: "+0519+16259",
      tz: "Pacific/Kosrae",
    },
    {
      comments: "Pohnpei/Ponape",
      coordinates: "+0658+15813",
      tz: "Pacific/Pohnpei",
    },
  ],
  FO: [
    {
      comments: "",
      coordinates: "+6201-00646",
      tz: "Atlantic/Faroe",
    },
  ],
  FR: [
    {
      comments: "",
      coordinates: "+4852+00220",
      tz: "Europe/Paris",
    },
  ],
  GA: [
    {
      comments: "",
      coordinates: "+0023+00927",
      tz: "Africa/Libreville",
    },
  ],
  GB: [
    {
      comments: "",
      coordinates: "+513030-0000731",
      tz: "Europe/London",
    },
  ],
  GD: [
    {
      comments: "",
      coordinates: "+1203-06145",
      tz: "America/Grenada",
    },
  ],
  GE: [
    {
      comments: "",
      coordinates: "+4143+04449",
      tz: "Asia/Tbilisi",
    },
  ],
  GF: [
    {
      comments: "",
      coordinates: "+0456-05220",
      tz: "America/Cayenne",
    },
  ],
  GG: [
    {
      comments: "",
      coordinates: "+492717-0023210",
      tz: "Europe/Guernsey",
    },
  ],
  GH: [
    {
      comments: "",
      coordinates: "+0533-00013",
      tz: "Africa/Accra",
    },
  ],
  GI: [
    {
      comments: "",
      coordinates: "+3608-00521",
      tz: "Europe/Gibraltar",
    },
  ],
  GL: [
    {
      comments: "National Park (east coast)",
      coordinates: "+7646-01840",
      tz: "America/Danmarkshavn",
    },
    {
      comments: "most of Greenland",
      coordinates: "+6411-05144",
      tz: "America/Nuuk",
    },
    {
      comments: "Scoresbysund/Ittoqqortoormiit",
      coordinates: "+7029-02158",
      tz: "America/Scoresbysund",
    },
    {
      comments: "Thule/Pituffik",
      coordinates: "+7634-06847",
      tz: "America/Thule",
    },
  ],
  GM: [
    {
      comments: "",
      coordinates: "+1328-01639",
      tz: "Africa/Banjul",
    },
  ],
  GN: [
    {
      comments: "",
      coordinates: "+0931-01343",
      tz: "Africa/Conakry",
    },
  ],
  GP: [
    {
      comments: "",
      coordinates: "+1614-06132",
      tz: "America/Guadeloupe",
    },
  ],
  GQ: [
    {
      comments: "",
      coordinates: "+0345+00847",
      tz: "Africa/Malabo",
    },
  ],
  GR: [
    {
      comments: "",
      coordinates: "+3758+02343",
      tz: "Europe/Athens",
    },
  ],
  GS: [
    {
      comments: "",
      coordinates: "-5416-03632",
      tz: "Atlantic/South_Georgia",
    },
  ],
  GT: [
    {
      comments: "",
      coordinates: "+1438-09031",
      tz: "America/Guatemala",
    },
  ],
  GU: [
    {
      comments: "",
      coordinates: "+1328+14445",
      tz: "Pacific/Guam",
    },
  ],
  GW: [
    {
      comments: "",
      coordinates: "+1151-01535",
      tz: "Africa/Bissau",
    },
  ],
  GY: [
    {
      comments: "",
      coordinates: "+0648-05810",
      tz: "America/Guyana",
    },
  ],
  HK: [
    {
      comments: "",
      coordinates: "+2217+11409",
      tz: "Asia/Hong_Kong",
    },
  ],
  HN: [
    {
      comments: "",
      coordinates: "+1406-08713",
      tz: "America/Tegucigalpa",
    },
  ],
  HR: [
    {
      comments: "",
      coordinates: "+4548+01558",
      tz: "Europe/Zagreb",
    },
  ],
  HT: [
    {
      comments: "",
      coordinates: "+1832-07220",
      tz: "America/Port-au-Prince",
    },
  ],
  HU: [
    {
      comments: "",
      coordinates: "+4730+01905",
      tz: "Europe/Budapest",
    },
  ],
  ID: [
    {
      comments: "Java, Sumatra",
      coordinates: "-0610+10648",
      tz: "Asia/Jakarta",
    },
    {
      comments: "New Guinea (West Papua / Irian Jaya), Malukus/Moluccas",
      coordinates: "-0232+14042",
      tz: "Asia/Jayapura",
    },
    {
      comments:
        "Borneo (east, south), Sulawesi/Celebes, Bali, Nusa Tengarra, Timor (west)",
      coordinates: "-0507+11924",
      tz: "Asia/Makassar",
    },
    {
      comments: "Borneo (west, central)",
      coordinates: "-0002+10920",
      tz: "Asia/Pontianak",
    },
  ],
  IE: [
    {
      comments: "",
      coordinates: "+5320-00615",
      tz: "Europe/Dublin",
    },
  ],
  IL: [
    {
      comments: "",
      coordinates: "+314650+0351326",
      tz: "Asia/Jerusalem",
    },
  ],
  IM: [
    {
      comments: "",
      coordinates: "+5409-00428",
      tz: "Europe/Isle_of_Man",
    },
  ],
  IN: [
    {
      comments: "",
      coordinates: "+2232+08822",
      tz: "Asia/Kolkata",
    },
  ],
  IO: [
    {
      comments: "",
      coordinates: "-0720+07225",
      tz: "Indian/Chagos",
    },
  ],
  IQ: [
    {
      comments: "",
      coordinates: "+3321+04425",
      tz: "Asia/Baghdad",
    },
  ],
  IR: [
    {
      comments: "",
      coordinates: "+3540+05126",
      tz: "Asia/Tehran",
    },
  ],
  IS: [
    {
      comments: "",
      coordinates: "+6409-02151",
      tz: "Atlantic/Reykjavik",
    },
  ],
  IT: [
    {
      comments: "",
      coordinates: "+4154+01229",
      tz: "Europe/Rome",
    },
  ],
  JE: [
    {
      comments: "",
      coordinates: "+491101-0020624",
      tz: "Europe/Jersey",
    },
  ],
  JM: [
    {
      comments: "",
      coordinates: "+175805-0764736",
      tz: "America/Jamaica",
    },
  ],
  JO: [
    {
      comments: "",
      coordinates: "+3157+03556",
      tz: "Asia/Amman",
    },
  ],
  JP: [
    {
      comments: "",
      coordinates: "+353916+1394441",
      tz: "Asia/Tokyo",
    },
  ],
  KE: [
    {
      comments: "",
      coordinates: "-0117+03649",
      tz: "Africa/Nairobi",
    },
  ],
  KG: [
    {
      comments: "",
      coordinates: "+4254+07436",
      tz: "Asia/Bishkek",
    },
  ],
  KH: [
    {
      comments: "",
      coordinates: "+1133+10455",
      tz: "Asia/Phnom_Penh",
    },
  ],
  KI: [
    {
      comments: "Phoenix Islands",
      coordinates: "-0247-17143",
      tz: "Pacific/Kanton",
    },
    {
      comments: "Line Islands",
      coordinates: "+0152-15720",
      tz: "Pacific/Kiritimati",
    },
    {
      comments: "Gilbert Islands",
      coordinates: "+0125+17300",
      tz: "Pacific/Tarawa",
    },
  ],
  KM: [
    {
      comments: "",
      coordinates: "-1141+04316",
      tz: "Indian/Comoro",
    },
  ],
  KN: [
    {
      comments: "",
      coordinates: "+1718-06243",
      tz: "America/St_Kitts",
    },
  ],
  KP: [
    {
      comments: "",
      coordinates: "+3901+12545",
      tz: "Asia/Pyongyang",
    },
  ],
  KR: [
    {
      comments: "",
      coordinates: "+3733+12658",
      tz: "Asia/Seoul",
    },
  ],
  KW: [
    {
      comments: "",
      coordinates: "+2920+04759",
      tz: "Asia/Kuwait",
    },
  ],
  KY: [
    {
      comments: "",
      coordinates: "+1918-08123",
      tz: "America/Cayman",
    },
  ],
  KZ: [
    {
      comments: "most of Kazakhstan",
      coordinates: "+4315+07657",
      tz: "Asia/Almaty",
    },
    {
      comments: "Mangghystau/Mankistau",
      coordinates: "+4431+05016",
      tz: "Asia/Aqtau",
    },
    {
      comments: "Aqtobe/Aktobe",
      coordinates: "+5017+05710",
      tz: "Asia/Aqtobe",
    },
    {
      comments: "Atyrau/Atirau/Gur'yev",
      coordinates: "+4707+05156",
      tz: "Asia/Atyrau",
    },
    {
      comments: "West Kazakhstan",
      coordinates: "+5113+05121",
      tz: "Asia/Oral",
    },
    {
      comments: "Qostanay/Kostanay/Kustanay",
      coordinates: "+5312+06337",
      tz: "Asia/Qostanay",
    },
    {
      comments: "Qyzylorda/Kyzylorda/Kzyl-Orda",
      coordinates: "+4448+06528",
      tz: "Asia/Qyzylorda",
    },
  ],
  LA: [
    {
      comments: "",
      coordinates: "+1758+10236",
      tz: "Asia/Vientiane",
    },
  ],
  LB: [
    {
      comments: "",
      coordinates: "+3353+03530",
      tz: "Asia/Beirut",
    },
  ],
  LC: [
    {
      comments: "",
      coordinates: "+1401-06100",
      tz: "America/St_Lucia",
    },
  ],
  LI: [
    {
      comments: "",
      coordinates: "+4709+00931",
      tz: "Europe/Vaduz",
    },
  ],
  LK: [
    {
      comments: "",
      coordinates: "+0656+07951",
      tz: "Asia/Colombo",
    },
  ],
  LR: [
    {
      comments: "",
      coordinates: "+0618-01047",
      tz: "Africa/Monrovia",
    },
  ],
  LS: [
    {
      comments: "",
      coordinates: "-2928+02730",
      tz: "Africa/Maseru",
    },
  ],
  LT: [
    {
      comments: "",
      coordinates: "+5441+02519",
      tz: "Europe/Vilnius",
    },
  ],
  LU: [
    {
      comments: "",
      coordinates: "+4936+00609",
      tz: "Europe/Luxembourg",
    },
  ],
  LV: [
    {
      comments: "",
      coordinates: "+5657+02406",
      tz: "Europe/Riga",
    },
  ],
  LY: [
    {
      comments: "",
      coordinates: "+3254+01311",
      tz: "Africa/Tripoli",
    },
  ],
  MA: [
    {
      comments: "",
      coordinates: "+3339-00735",
      tz: "Africa/Casablanca",
    },
  ],
  MC: [
    {
      comments: "",
      coordinates: "+4342+00723",
      tz: "Europe/Monaco",
    },
  ],
  MD: [
    {
      comments: "",
      coordinates: "+4700+02850",
      tz: "Europe/Chisinau",
    },
  ],
  ME: [
    {
      comments: "",
      coordinates: "+4226+01916",
      tz: "Europe/Podgorica",
    },
  ],
  MF: [
    {
      comments: "",
      coordinates: "+1804-06305",
      tz: "America/Marigot",
    },
  ],
  MG: [
    {
      comments: "",
      coordinates: "-1855+04731",
      tz: "Indian/Antananarivo",
    },
  ],
  MH: [
    {
      comments: "Kwajalein",
      coordinates: "+0905+16720",
      tz: "Pacific/Kwajalein",
    },
    {
      comments: "most of Marshall Islands",
      coordinates: "+0709+17112",
      tz: "Pacific/Majuro",
    },
  ],
  MK: [
    {
      comments: "",
      coordinates: "+4159+02126",
      tz: "Europe/Skopje",
    },
  ],
  ML: [
    {
      comments: "",
      coordinates: "+1239-00800",
      tz: "Africa/Bamako",
    },
  ],
  MM: [
    {
      comments: "",
      coordinates: "+1647+09610",
      tz: "Asia/Yangon",
    },
  ],
  MN: [
    {
      comments: "Bayan-Olgii, Hovd, Uvs",
      coordinates: "+4801+09139",
      tz: "Asia/Hovd",
    },
    {
      comments: "most of Mongolia",
      coordinates: "+4755+10653",
      tz: "Asia/Ulaanbaatar",
    },
  ],
  MO: [
    {
      comments: "",
      coordinates: "+221150+1133230",
      tz: "Asia/Macau",
    },
  ],
  MP: [
    {
      comments: "",
      coordinates: "+1512+14545",
      tz: "Pacific/Saipan",
    },
  ],
  MQ: [
    {
      comments: "",
      coordinates: "+1436-06105",
      tz: "America/Martinique",
    },
  ],
  MR: [
    {
      comments: "",
      coordinates: "+1806-01557",
      tz: "Africa/Nouakchott",
    },
  ],
  MS: [
    {
      comments: "",
      coordinates: "+1643-06213",
      tz: "America/Montserrat",
    },
  ],
  MT: [
    {
      comments: "",
      coordinates: "+3554+01431",
      tz: "Europe/Malta",
    },
  ],
  MU: [
    {
      comments: "",
      coordinates: "-2010+05730",
      tz: "Indian/Mauritius",
    },
  ],
  MV: [
    {
      comments: "",
      coordinates: "+0410+07330",
      tz: "Indian/Maldives",
    },
  ],
  MW: [
    {
      comments: "",
      coordinates: "-1547+03500",
      tz: "Africa/Blantyre",
    },
  ],
  MX: [
    {
      comments: "Bahia de Banderas",
      coordinates: "+2048-10515",
      tz: "America/Bahia_Banderas",
    },
    {
      comments: "Quintana Roo",
      coordinates: "+2105-08646",
      tz: "America/Cancun",
    },
    {
      comments: "Chihuahua (most areas)",
      coordinates: "+2838-10605",
      tz: "America/Chihuahua",
    },
    {
      comments: "Chihuahua (US border - west)",
      coordinates: "+3144-10629",
      tz: "America/Ciudad_Juarez",
    },
    {
      comments: "Sonora",
      coordinates: "+2904-11058",
      tz: "America/Hermosillo",
    },
    {
      comments: "Coahuila, Nuevo Leon, Tamaulipas (US border)",
      coordinates: "+2550-09730",
      tz: "America/Matamoros",
    },
    {
      comments: "Baja California Sur, Nayarit (most areas), Sinaloa",
      coordinates: "+2313-10625",
      tz: "America/Mazatlan",
    },
    {
      comments: "Campeche, Yucatan",
      coordinates: "+2058-08937",
      tz: "America/Merida",
    },
    {
      comments: "Central Mexico",
      coordinates: "+1924-09909",
      tz: "America/Mexico_City",
    },
    {
      comments: "Durango; Coahuila, Nuevo Leon, Tamaulipas (most areas)",
      coordinates: "+2540-10019",
      tz: "America/Monterrey",
    },
    {
      comments: "Chihuahua (US border - east)",
      coordinates: "+2934-10425",
      tz: "America/Ojinaga",
    },
    {
      comments: "Baja California",
      coordinates: "+3232-11701",
      tz: "America/Tijuana",
    },
  ],
  MY: [
    {
      comments: "Malaysia (peninsula)",
      coordinates: "+0310+10142",
      tz: "Asia/Kuala_Lumpur",
    },
    {
      comments: "Sabah, Sarawak",
      coordinates: "+0133+11020",
      tz: "Asia/Kuching",
    },
  ],
  MZ: [
    {
      comments: "",
      coordinates: "-2558+03235",
      tz: "Africa/Maputo",
    },
  ],
  NA: [
    {
      comments: "",
      coordinates: "-2234+01706",
      tz: "Africa/Windhoek",
    },
  ],
  NC: [
    {
      comments: "",
      coordinates: "-2216+16627",
      tz: "Pacific/Noumea",
    },
  ],
  NE: [
    {
      comments: "",
      coordinates: "+1331+00207",
      tz: "Africa/Niamey",
    },
  ],
  NF: [
    {
      comments: "",
      coordinates: "-2903+16758",
      tz: "Pacific/Norfolk",
    },
  ],
  NG: [
    {
      comments: "",
      coordinates: "+0627+00324",
      tz: "Africa/Lagos",
    },
  ],
  NI: [
    {
      comments: "",
      coordinates: "+1209-08617",
      tz: "America/Managua",
    },
  ],
  NL: [
    {
      comments: "",
      coordinates: "+5222+00454",
      tz: "Europe/Amsterdam",
    },
  ],
  NO: [
    {
      comments: "",
      coordinates: "+5955+01045",
      tz: "Europe/Oslo",
    },
  ],
  NP: [
    {
      comments: "",
      coordinates: "+2743+08519",
      tz: "Asia/Kathmandu",
    },
  ],
  NR: [
    {
      comments: "",
      coordinates: "-0031+16655",
      tz: "Pacific/Nauru",
    },
  ],
  NU: [
    {
      comments: "",
      coordinates: "-1901-16955",
      tz: "Pacific/Niue",
    },
  ],
  NZ: [
    {
      comments: "most of New Zealand",
      coordinates: "-3652+17446",
      tz: "Pacific/Auckland",
    },
    {
      comments: "Chatham Islands",
      coordinates: "-4357-17633",
      tz: "Pacific/Chatham",
    },
  ],
  OM: [
    {
      comments: "",
      coordinates: "+2336+05835",
      tz: "Asia/Muscat",
    },
  ],
  PA: [
    {
      comments: "",
      coordinates: "+0858-07932",
      tz: "America/Panama",
    },
  ],
  PE: [
    {
      comments: "",
      coordinates: "-1203-07703",
      tz: "America/Lima",
    },
  ],
  PF: [
    {
      comments: "Gambier Islands",
      coordinates: "-2308-13457",
      tz: "Pacific/Gambier",
    },
    {
      comments: "Marquesas Islands",
      coordinates: "-0900-13930",
      tz: "Pacific/Marquesas",
    },
    {
      comments: "Society Islands",
      coordinates: "-1732-14934",
      tz: "Pacific/Tahiti",
    },
  ],
  PG: [
    {
      comments: "Bougainville",
      coordinates: "-0613+15534",
      tz: "Pacific/Bougainville",
    },
    {
      comments: "most of Papua New Guinea",
      coordinates: "-0930+14710",
      tz: "Pacific/Port_Moresby",
    },
  ],
  PH: [
    {
      comments: "",
      coordinates: "+143512+1205804",
      tz: "Asia/Manila",
    },
  ],
  PK: [
    {
      comments: "",
      coordinates: "+2452+06703",
      tz: "Asia/Karachi",
    },
  ],
  PL: [
    {
      comments: "",
      coordinates: "+5215+02100",
      tz: "Europe/Warsaw",
    },
  ],
  PM: [
    {
      comments: "",
      coordinates: "+4703-05620",
      tz: "America/Miquelon",
    },
  ],
  PN: [
    {
      comments: "",
      coordinates: "-2504-13005",
      tz: "Pacific/Pitcairn",
    },
  ],
  PR: [
    {
      comments: "",
      coordinates: "+182806-0660622",
      tz: "America/Puerto_Rico",
    },
  ],
  PS: [
    {
      comments: "Gaza Strip",
      coordinates: "+3130+03428",
      tz: "Asia/Gaza",
    },
    {
      comments: "West Bank",
      coordinates: "+313200+0350542",
      tz: "Asia/Hebron",
    },
  ],
  PT: [
    {
      comments: "Azores",
      coordinates: "+3744-02540",
      tz: "Atlantic/Azores",
    },
    {
      comments: "Madeira Islands",
      coordinates: "+3238-01654",
      tz: "Atlantic/Madeira",
    },
    {
      comments: "Portugal (mainland)",
      coordinates: "+3843-00908",
      tz: "Europe/Lisbon",
    },
  ],
  PW: [
    {
      comments: "",
      coordinates: "+0720+13429",
      tz: "Pacific/Palau",
    },
  ],
  PY: [
    {
      comments: "",
      coordinates: "-2516-05740",
      tz: "America/Asuncion",
    },
  ],
  QA: [
    {
      comments: "",
      coordinates: "+2517+05132",
      tz: "Asia/Qatar",
    },
  ],
  RE: [
    {
      comments: "",
      coordinates: "-2052+05528",
      tz: "Indian/Reunion",
    },
  ],
  RO: [
    {
      comments: "",
      coordinates: "+4426+02606",
      tz: "Europe/Bucharest",
    },
  ],
  RS: [
    {
      comments: "",
      coordinates: "+4450+02030",
      tz: "Europe/Belgrade",
    },
  ],
  RU: [
    {
      comments: "MSK+09 - Bering Sea",
      coordinates: "+6445+17729",
      tz: "Asia/Anadyr",
    },
    {
      comments: "MSK+04 - Altai",
      coordinates: "+5322+08345",
      tz: "Asia/Barnaul",
    },
    {
      comments: "MSK+06 - Zabaykalsky",
      coordinates: "+5203+11328",
      tz: "Asia/Chita",
    },
    {
      comments: "MSK+05 - Irkutsk, Buryatia",
      coordinates: "+5216+10420",
      tz: "Asia/Irkutsk",
    },
    {
      comments: "MSK+09 - Kamchatka",
      coordinates: "+5301+15839",
      tz: "Asia/Kamchatka",
    },
    {
      comments: "MSK+06 - Tomponsky, Ust-Maysky",
      coordinates: "+623923+1353314",
      tz: "Asia/Khandyga",
    },
    {
      comments: "MSK+04 - Krasnoyarsk area",
      coordinates: "+5601+09250",
      tz: "Asia/Krasnoyarsk",
    },
    {
      comments: "MSK+08 - Magadan",
      coordinates: "+5934+15048",
      tz: "Asia/Magadan",
    },
    {
      comments: "MSK+04 - Kemerovo",
      coordinates: "+5345+08707",
      tz: "Asia/Novokuznetsk",
    },
    {
      comments: "MSK+04 - Novosibirsk",
      coordinates: "+5502+08255",
      tz: "Asia/Novosibirsk",
    },
    {
      comments: "MSK+03 - Omsk",
      coordinates: "+5500+07324",
      tz: "Asia/Omsk",
    },
    {
      comments: "MSK+08 - Sakhalin Island",
      coordinates: "+4658+14242",
      tz: "Asia/Sakhalin",
    },
    {
      comments: "MSK+08 - Sakha (E), N Kuril Is",
      coordinates: "+6728+15343",
      tz: "Asia/Srednekolymsk",
    },
    {
      comments: "MSK+04 - Tomsk",
      coordinates: "+5630+08458",
      tz: "Asia/Tomsk",
    },
    {
      comments: "MSK+07 - Oymyakonsky",
      coordinates: "+643337+1431336",
      tz: "Asia/Ust-Nera",
    },
    {
      comments: "MSK+07 - Amur River",
      coordinates: "+4310+13156",
      tz: "Asia/Vladivostok",
    },
    {
      comments: "MSK+06 - Lena River",
      coordinates: "+6200+12940",
      tz: "Asia/Yakutsk",
    },
    {
      comments: "MSK+02 - Urals",
      coordinates: "+5651+06036",
      tz: "Asia/Yekaterinburg",
    },
    {
      comments: "MSK+01 - Astrakhan",
      coordinates: "+4621+04803",
      tz: "Europe/Astrakhan",
    },
    {
      comments: "MSK-01 - Kaliningrad",
      coordinates: "+5443+02030",
      tz: "Europe/Kaliningrad",
    },
    {
      comments: "MSK+00 - Kirov",
      coordinates: "+5836+04939",
      tz: "Europe/Kirov",
    },
    {
      comments: "MSK+00 - Moscow area",
      coordinates: "+554521+0373704",
      tz: "Europe/Moscow",
    },
    {
      comments: "MSK+01 - Samara, Udmurtia",
      coordinates: "+5312+05009",
      tz: "Europe/Samara",
    },
    {
      comments: "MSK+01 - Saratov",
      coordinates: "+5134+04602",
      tz: "Europe/Saratov",
    },
    {
      comments: "MSK+01 - Ulyanovsk",
      coordinates: "+5420+04824",
      tz: "Europe/Ulyanovsk",
    },
    {
      comments: "MSK+00 - Volgograd",
      coordinates: "+4844+04425",
      tz: "Europe/Volgograd",
    },
  ],
  RW: [
    {
      comments: "",
      coordinates: "-0157+03004",
      tz: "Africa/Kigali",
    },
  ],
  SA: [
    {
      comments: "",
      coordinates: "+2438+04643",
      tz: "Asia/Riyadh",
    },
  ],
  SB: [
    {
      comments: "",
      coordinates: "-0932+16012",
      tz: "Pacific/Guadalcanal",
    },
  ],
  SC: [
    {
      comments: "",
      coordinates: "-0440+05528",
      tz: "Indian/Mahe",
    },
  ],
  SD: [
    {
      comments: "",
      coordinates: "+1536+03232",
      tz: "Africa/Khartoum",
    },
  ],
  SE: [
    {
      comments: "",
      coordinates: "+5920+01803",
      tz: "Europe/Stockholm",
    },
  ],
  SG: [
    {
      comments: "",
      coordinates: "+0117+10351",
      tz: "Asia/Singapore",
    },
  ],
  SH: [
    {
      comments: "",
      coordinates: "-1555-00542",
      tz: "Atlantic/St_Helena",
    },
  ],
  SI: [
    {
      comments: "",
      coordinates: "+4603+01431",
      tz: "Europe/Ljubljana",
    },
  ],
  SJ: [
    {
      comments: "",
      coordinates: "+7800+01600",
      tz: "Arctic/Longyearbyen",
    },
  ],
  SK: [
    {
      comments: "",
      coordinates: "+4809+01707",
      tz: "Europe/Bratislava",
    },
  ],
  SL: [
    {
      comments: "",
      coordinates: "+0830-01315",
      tz: "Africa/Freetown",
    },
  ],
  SM: [
    {
      comments: "",
      coordinates: "+4355+01228",
      tz: "Europe/San_Marino",
    },
  ],
  SN: [
    {
      comments: "",
      coordinates: "+1440-01726",
      tz: "Africa/Dakar",
    },
  ],
  SO: [
    {
      comments: "",
      coordinates: "+0204+04522",
      tz: "Africa/Mogadishu",
    },
  ],
  SR: [
    {
      comments: "",
      coordinates: "+0550-05510",
      tz: "America/Paramaribo",
    },
  ],
  SS: [
    {
      comments: "",
      coordinates: "+0451+03137",
      tz: "Africa/Juba",
    },
  ],
  ST: [
    {
      comments: "",
      coordinates: "+0020+00644",
      tz: "Africa/Sao_Tome",
    },
  ],
  SV: [
    {
      comments: "",
      coordinates: "+1342-08912",
      tz: "America/El_Salvador",
    },
  ],
  SX: [
    {
      comments: "",
      coordinates: "+180305-0630250",
      tz: "America/Lower_Princes",
    },
  ],
  SY: [
    {
      comments: "",
      coordinates: "+3330+03618",
      tz: "Asia/Damascus",
    },
  ],
  SZ: [
    {
      comments: "",
      coordinates: "-2618+03106",
      tz: "Africa/Mbabane",
    },
  ],
  TC: [
    {
      comments: "",
      coordinates: "+2128-07108",
      tz: "America/Grand_Turk",
    },
  ],
  TD: [
    {
      comments: "",
      coordinates: "+1207+01503",
      tz: "Africa/Ndjamena",
    },
  ],
  TF: [
    {
      comments: "",
      coordinates: "-492110+0701303",
      tz: "Indian/Kerguelen",
    },
  ],
  TG: [
    {
      comments: "",
      coordinates: "+0608+00113",
      tz: "Africa/Lome",
    },
  ],
  TH: [
    {
      comments: "",
      coordinates: "+1345+10031",
      tz: "Asia/Bangkok",
    },
  ],
  TJ: [
    {
      comments: "",
      coordinates: "+3835+06848",
      tz: "Asia/Dushanbe",
    },
  ],
  TK: [
    {
      comments: "",
      coordinates: "-0922-17114",
      tz: "Pacific/Fakaofo",
    },
  ],
  TL: [
    {
      comments: "",
      coordinates: "-0833+12535",
      tz: "Asia/Dili",
    },
  ],
  TM: [
    {
      comments: "",
      coordinates: "+3757+05823",
      tz: "Asia/Ashgabat",
    },
  ],
  TN: [
    {
      comments: "",
      coordinates: "+3648+01011",
      tz: "Africa/Tunis",
    },
  ],
  TO: [
    {
      comments: "",
      coordinates: "-210800-1751200",
      tz: "Pacific/Tongatapu",
    },
  ],
  TR: [
    {
      comments: "",
      coordinates: "+4101+02858",
      tz: "Europe/Istanbul",
    },
  ],
  TT: [
    {
      comments: "",
      coordinates: "+1039-06131",
      tz: "America/Port_of_Spain",
    },
  ],
  TV: [
    {
      comments: "",
      coordinates: "-0831+17913",
      tz: "Pacific/Funafuti",
    },
  ],
  TW: [
    {
      comments: "",
      coordinates: "+2503+12130",
      tz: "Asia/Taipei",
    },
  ],
  TZ: [
    {
      comments: "",
      coordinates: "-0648+03917",
      tz: "Africa/Dar_es_Salaam",
    },
  ],
  UA: [
    {
      comments: "most of Ukraine",
      coordinates: "+5026+03031",
      tz: "Europe/Kyiv",
    },
    {
      comments: "Crimea",
      coordinates: "+4457+03406",
      tz: "Europe/Simferopol",
    },
  ],
  UG: [
    {
      comments: "",
      coordinates: "+0019+03225",
      tz: "Africa/Kampala",
    },
  ],
  UM: [
    {
      comments: "Midway Islands",
      coordinates: "+2813-17722",
      tz: "Pacific/Midway",
    },
    {
      comments: "Wake Island",
      coordinates: "+1917+16637",
      tz: "Pacific/Wake",
    },
  ],
  US: [
    {
      comments: "Alaska - western Aleutians",
      coordinates: "+515248-1763929",
      tz: "America/Adak",
    },
    {
      comments: "Alaska (most areas)",
      coordinates: "+611305-1495401",
      tz: "America/Anchorage",
    },
    {
      comments: "Mountain - ID (south), OR (east)",
      coordinates: "+433649-1161209",
      tz: "America/Boise",
    },
    {
      comments: "Central (most areas)",
      coordinates: "+415100-0873900",
      tz: "America/Chicago",
    },
    {
      comments: "Mountain (most areas)",
      coordinates: "+394421-1045903",
      tz: "America/Denver",
    },
    {
      comments: "Eastern - MI (most areas)",
      coordinates: "+421953-0830245",
      tz: "America/Detroit",
    },
    {
      comments: "Eastern - IN (most areas)",
      coordinates: "+394606-0860929",
      tz: "America/Indiana/Indianapolis",
    },
    {
      comments: "Central - IN (Starke)",
      coordinates: "+411745-0863730",
      tz: "America/Indiana/Knox",
    },
    {
      comments: "Eastern - IN (Crawford)",
      coordinates: "+382232-0862041",
      tz: "America/Indiana/Marengo",
    },
    {
      comments: "Eastern - IN (Pike)",
      coordinates: "+382931-0871643",
      tz: "America/Indiana/Petersburg",
    },
    {
      comments: "Central - IN (Perry)",
      coordinates: "+375711-0864541",
      tz: "America/Indiana/Tell_City",
    },
    {
      comments: "Eastern - IN (Switzerland)",
      coordinates: "+384452-0850402",
      tz: "America/Indiana/Vevay",
    },
    {
      comments: "Eastern - IN (Da, Du, K, Mn)",
      coordinates: "+384038-0873143",
      tz: "America/Indiana/Vincennes",
    },
    {
      comments: "Eastern - IN (Pulaski)",
      coordinates: "+410305-0863611",
      tz: "America/Indiana/Winamac",
    },
    {
      comments: "Alaska - Juneau area",
      coordinates: "+581807-1342511",
      tz: "America/Juneau",
    },
    {
      comments: "Eastern - KY (Louisville area)",
      coordinates: "+381515-0854534",
      tz: "America/Kentucky/Louisville",
    },
    {
      comments: "Eastern - KY (Wayne)",
      coordinates: "+364947-0845057",
      tz: "America/Kentucky/Monticello",
    },
    {
      comments: "Pacific",
      coordinates: "+340308-1181434",
      tz: "America/Los_Angeles",
    },
    {
      comments: "Central - MI (Wisconsin border)",
      coordinates: "+450628-0873651",
      tz: "America/Menominee",
    },
    {
      comments: "Alaska - Annette Island",
      coordinates: "+550737-1313435",
      tz: "America/Metlakatla",
    },
    {
      comments: "Eastern (most areas)",
      coordinates: "+404251-0740023",
      tz: "America/New_York",
    },
    {
      comments: "Alaska (west)",
      coordinates: "+643004-1652423",
      tz: "America/Nome",
    },
    {
      comments: "Central - ND (Mercer)",
      coordinates: "+471551-1014640",
      tz: "America/North_Dakota/Beulah",
    },
    {
      comments: "Central - ND (Oliver)",
      coordinates: "+470659-1011757",
      tz: "America/North_Dakota/Center",
    },
    {
      comments: "Central - ND (Morton rural)",
      coordinates: "+465042-1012439",
      tz: "America/North_Dakota/New_Salem",
    },
    {
      comments: "MST - AZ (except Navajo)",
      coordinates: "+332654-1120424",
      tz: "America/Phoenix",
    },
    {
      comments: "Alaska - Sitka area",
      coordinates: "+571035-1351807",
      tz: "America/Sitka",
    },
    {
      comments: "Alaska - Yakutat",
      coordinates: "+593249-1394338",
      tz: "America/Yakutat",
    },
    {
      comments: "Hawaii",
      coordinates: "+211825-1575130",
      tz: "Pacific/Honolulu",
    },
  ],
  UY: [
    {
      comments: "",
      coordinates: "-345433-0561245",
      tz: "America/Montevideo",
    },
  ],
  UZ: [
    {
      comments: "Uzbekistan (west)",
      coordinates: "+3940+06648",
      tz: "Asia/Samarkand",
    },
    {
      comments: "Uzbekistan (east)",
      coordinates: "+4120+06918",
      tz: "Asia/Tashkent",
    },
  ],
  VA: [
    {
      comments: "",
      coordinates: "+415408+0122711",
      tz: "Europe/Vatican",
    },
  ],
  VC: [
    {
      comments: "",
      coordinates: "+1309-06114",
      tz: "America/St_Vincent",
    },
  ],
  VE: [
    {
      comments: "",
      coordinates: "+1030-06656",
      tz: "America/Caracas",
    },
  ],
  VG: [
    {
      comments: "",
      coordinates: "+1827-06437",
      tz: "America/Tortola",
    },
  ],
  VI: [
    {
      comments: "",
      coordinates: "+1821-06456",
      tz: "America/St_Thomas",
    },
  ],
  VN: [
    {
      comments: "",
      coordinates: "+1045+10640",
      tz: "Asia/Ho_Chi_Minh",
    },
  ],
  VU: [
    {
      comments: "",
      coordinates: "-1740+16825",
      tz: "Pacific/Efate",
    },
  ],
  WF: [
    {
      comments: "",
      coordinates: "-1318-17610",
      tz: "Pacific/Wallis",
    },
  ],
  WS: [
    {
      comments: "",
      coordinates: "-1350-17144",
      tz: "Pacific/Apia",
    },
  ],
  YE: [
    {
      comments: "",
      coordinates: "+1245+04512",
      tz: "Asia/Aden",
    },
  ],
  YT: [
    {
      comments: "",
      coordinates: "-1247+04514",
      tz: "Indian/Mayotte",
    },
  ],
  ZA: [
    {
      comments: "",
      coordinates: "-2615+02800",
      tz: "Africa/Johannesburg",
    },
  ],
  ZM: [
    {
      comments: "",
      coordinates: "-1525+02817",
      tz: "Africa/Lusaka",
    },
  ],
  ZW: [
    {
      comments: "",
      coordinates: "-1750+03103",
      tz: "Africa/Harare",
    },
  ],
};

export default countryCodesToTimezones;
